module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABN0lEQVQ4ja2VPU4DQQxGvyACDUKgCGoKGkouA4gyEUHiDpwlIrkAFIQDgKig4gJIKAUbaKjoHvIyq2zWs3+IJ01jez55PGOPgNjaAM6BKZCw4B24BYYhxu11BmAAfFDPHOhXCa4BkwZCRa7CXif4F7GMSVFw4ELakx6/Y8WV9Cqpp+bMJH1JOsjt+JS0tyLptIXYg6RjSfuSNgu+XqoVnkEV38AIOMzV+6gkfqrwtmLMgEtgN/K07iPxRiJngkfgBOhGhBQyLSUmWMZWiB+V+FM6aZrSjiu/Z1tSV9KbpHXn/SWxW3525nLOKsSMJxO8duY4q5Iuop4FN9lkaTIMhs6yzDxtkhat9+Isy/T/czjYxImOL3O0ZVw2vrJlqVs96qgdsPllF2WXYH2eb037Du7C9+C/ANAPnIBb9WTm88kAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/navi_icon20.png
// module id = 249
// module chunks = 0